import { Layout } from "antd";
import { chakra, Text } from "@chakra-ui/react";

const { Footer } = Layout;

const SteyledFooter = chakra(Footer);

const FONT = "Montserrat, sans-serif";

const GlobalFooter = () => {
  return (
    <SteyledFooter textAlign="center" background="#001529" fontFamily={FONT}>
      <Text color="white">{`Powered by QV Labs. 2022 All rights reserved.`}</Text>
    </SteyledFooter>
  );
};

export default GlobalFooter;
